import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export type FacilityGroupRecord = QueryAtomResult<
  typeof queryFacilityGroupAtom
>;

export const queryFacilityGroupAtom = createQueryAtomFactory(
  'settings.facilityGroup',
  ({ id }: { id: string }) => ({
    facilityGroup: {
      __args: {
        id,
      },
      id: true,
      name: true,
      facilities: {
        id: true,
        facilityName: true,
        facilityType: true,
      },
      defaultFacility: {
        id: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data) => {
      if (!data?.facilityGroup) return undefined;

      return {
        id: data.facilityGroup.id,
        name: data.facilityGroup.name,
        facilities:
          data.facilityGroup.facilities?.map((facility) => ({
            id: facility.id,
            name: facility.facilityName,
            type: facility.facilityType,
          })) ?? [],
        defaultFacilityId: data.facilityGroup.defaultFacility?.id,
        timestamps: {
          createdAt: parseZonedDateTime(
            data.facilityGroup.timestamps.createdAt,
          ),
          updatedAt: parseZonedDateTime(
            data.facilityGroup.timestamps.updatedAt,
          ),
        },
      };
    },
  },
);
